import { useQuery } from 'react-query';
import { useApi } from '../../core/api/api.context';
import { AppRoleDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { fetchAllPages } from '../../core/queries/query-helpers';

export function useAllAllowedActionsList() {
  const api = useApi();

  return useQuery('PERMISSIONS', async () => {
    const appRoles: AppRoleDto[] = await fetchAllPages(
      async (pageNo) =>
        await api.appRolesController.list({
          pageNo,
          perPageRecords: 100
        })
    );
    return [...new Set(appRoles.map((role) => role.allowedActions || []).flat())].sort();
  });
}

export function useMyAllowedActionsList(projectID: string) {
  const api = useApi();

  return useQuery('MY-PERMISSIONS', async () => {
    const allRoles: AppRoleDto[] = await fetchAllPages(
      async (pageNo) =>
        await api.appRolesController.list({
          pageNo,
          perPageRecords: 100
        })
    );
    const account = await api.directoryController.whoami();
    const membership = await api.accountsController.projectsGet(account.account.id, projectID);
    const role = allRoles.find((role) => role.id === membership.accessLevel);
    return role?.allowedActions || [];
  });
}
